import ProductDimensions from './ProductDimensions';

export default ProductDimensions;
